import ip from './ip';

export const isAnyCidrEnabled = records =>
  records.some(record => record.enabled === true);

/**
 * Validate that the user input matches the expected generated string.
 * @param {String} value - CIDR value
 */
export const isValidCidr = value => {
  try {
    const cidrObject = ip.cidrSubnet(value);
    const { networkAddress, subnetMaskLength } = cidrObject;
    return value === `${networkAddress}/${subnetMaskLength}`;
  } catch {
    // ip.cidrSubnet(value) will throw an error and cause the page to crash if
    // the value isn't the proper format (1.1.1.0/24). This is a fallback
    // ip.isV6Format returns true for empty string
    return ip.isV4Format(value) || (value !== '' && ip.isV6Format(value));
  }
};

/**
 * Loop through the comma separated values of CIDR records. If any of them are
 * invalid, return false.
 * @param {String} values - comma separated values of CIDR records
 */
export const validateCidrs = values => {
  if (!values.length) {
    return false;
  }
  for (const value of values) {
    if (!isValidCidr(value)) {
      return false;
    }
  }
  return true;
};
